const cart = {
    title: 'Jouw Winkelwagen',
    subtitle: 'Bekijk je geselecteerde producten',
    errorLoading: 'Fout bij laden winkelwagen',
    errorUpdating: 'Fout bij bijwerken hoeveelheid',
    errorRemoving: 'Fout bij verwijderen product',
    errorClearing: 'Fout bij legen winkelwagen',
    confirmClear: 'Weet je zeker dat je de winkelwagen wilt legen?',
    emptyCart: 'Jouw winkelwagen is leeg',
    checkoutError: 'Fout tijdens checkout',
    items: 'artikelen',
    clearCart: 'Winkelwagen legen',
    emptyTitle: 'Lege Winkelwagen',
    emptySubtitle: 'Voeg wat producten toe om te beginnen',
    browseProducts: 'Blader door Producten',
    orderSummary: 'Besteloverzicht',
    productsSummary: 'Producten',
    subtotal: 'Subtotaal',
    shipping: 'Verzending',
    freeShipping: 'Gratis',
    total: 'Totaal',
    proceedToCheckout: 'Ga Door naar Checkout',
    processing: 'Verwerken...',
    secureCheckout: 'Veilige Checkout',
    shippingInfo: 'Verzendinformatie',
    selectShipping: 'Selecteer Verzending',
    shippingAddress: 'Verzendadres',
    useProfileAddress: 'Gebruik profieladres',
    editShippingAddress: 'Bewerken',
    address: 'Adres',
    city: 'Stad',
    postalCode: 'Postcode',
    country: 'Land',
    saveAddress: 'Adres Opslaan',
    hide: 'Verbergen',
    addShippingAddress: 'Verzendadres Toevoegen',
    shippingNotAvailable: 'Verzending Niet Beschikbaar',
    shippingNotAvailableMessage: 'We kunnen niet verzenden naar het geselecteerde adres. Kies een ander adres of neem contact met ons op voor hulp.',
    availableCountries: 'Landen beschikbaar voor verzending:'
};

export default cart;

